import { toast } from "react-toastify"
import axios from "./userInstance"
import { NewRole } from "@/types/role"
import {getErrorMessage} from "@/utils/errorMessages"
import notifyError from "@/utils/notifyError"

export default async (newRole: NewRole) => {
  try {
    const response = await axios.post(`/role/`, newRole)
    toast.success('Role created successfully');
    return response.data
  } catch (error: any) {
    const errorMessage = getErrorMessage(error)
    if (errorMessage === '409 Conflict: The role already exists.') {
        notifyError('The role already exists.')
    } else {
        notifyError(error)
    }
    return null
  }
}
